import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  useTheme,
  alpha,
  Stack,
  LinearProgress,
  Alert,
  Paper,
  Tooltip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPendingCorporateUsers, approveCorporateUser } from '../store/slices/adminSlice';
import {
  Business,
  CalendarToday,
  AccountBalance,
  CheckCircle,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PendingCorporateUsersPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { list: corporateUsers, loading, error } = useSelector(
    (state) => state.admin.pendingCorporateUsers
  );

  useEffect(() => {
    dispatch(fetchPendingCorporateUsers());
  }, [dispatch]);

  const handleApprove = async (userId) => {
    try {
      await dispatch(approveCorporateUser(userId)).unwrap();
      toast.success('Kullanıcı onaylandı');
    } catch (error) {
      console.log(error)
      toast.error(error.message);
    }
  };

  if (error) {
    return (
      <Container maxWidth="lg">
        <Alert severity="error" sx={{ mt: 4 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 4,
            mb: 4,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${alpha(theme.palette.warning.main, 0.1)}, ${alpha(theme.palette.warning.main, 0.05)})`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Business sx={{ fontSize: 40, color: theme.palette.warning.main }} />
            <Box>
              <Typography variant="h4" gutterBottom>
                Onay Bekleyen Kurumsal Kullanıcılar
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {corporateUsers.length} kurumsal kullanıcı onay bekliyor
              </Typography>
            </Box>
          </Stack>
        </Paper>

        <Card sx={{ borderRadius: 2 }}>
          {loading && <LinearProgress />}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Şirket Adı</TableCell>
                  <TableCell>Vergi Dairesi</TableCell>
                  <TableCell>Vergi Numarası</TableCell>
                  <TableCell>Kayıt Tarihi</TableCell>
                  <TableCell align="right">İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {corporateUsers.map((user) => (
                  <TableRow key={user.userId}>
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Business fontSize="small" color="action" />
                        <Typography variant="body2">{user.title}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <AccountBalance fontSize="small" color="action" />
                        <Typography variant="body2">{user.taxOffice}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>{user.taxNumber}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <CalendarToday fontSize="small" color="action" />
                        <Typography variant="body2">
                          {new Date(parseInt(user.registerTime)).toLocaleDateString('tr-TR')}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="right">
                      <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<CheckCircle />}
                          onClick={() => handleApprove(user.userId)}
                          sx={{
                            bgcolor: theme.palette.success.main,
                            '&:hover': {
                              bgcolor: theme.palette.success.dark,
                            },
                          }}
                        >
                          Onayla
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => navigate(`/kullanici/${user.userId}`)}
                          sx={{
                            borderColor: theme.palette.primary.main,
                            color: theme.palette.primary.main,
                            '&:hover': {
                              borderColor: theme.palette.primary.dark,
                              bgcolor: alpha(theme.palette.primary.main, 0.1),
                            },
                          }}
                        >
                          Detay
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
                {corporateUsers.length === 0 && !loading && (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                      <Typography color="text.secondary">
                        Onay bekleyen kurumsal kullanıcı bulunmuyor
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Box>
    </Container>
  );
};

export default PendingCorporateUsersPage; 